export function typesetNodeIntoElement(nodeOrText, element, state) {
    if (!element) {
        return;
    }

    if (typeof nodeOrText === "string") {
        element.textContent = nodeOrText;
        return;
    }

    if (nodeOrText && typeof nodeOrText.from === "number" && typeof nodeOrText.to === "number" && state) {
        element.textContent = state.sliceDoc(nodeOrText.from, nodeOrText.to);
        return;
    }

    element.textContent = "";
}
